// Tiny hook the three Workflow Hygiene cards use to open their drill-down
// tab (PRODOPSAI-385). Centralises the URL-state mutation so each card
// stays a one-liner — and so the tab-value enum lives in one place rather
// than being duplicated across the three card files (SC duplication risk
// per memory `feedback_duplication_when_mirroring.md`).

import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { DrillSource } from './HygieneDrillTab';

const SOURCE_TO_TAB: Record<DrillSource, string> = {
  unlinked: 'hygiene-drill-unlinked',
  statuses: 'hygiene-drill-statuses',
  types: 'hygiene-drill-types',
};

export function useOpenDrill(): (source: DrillSource) => void {
  const [, setSearchParams] = useSearchParams();

  return useCallback((source: DrillSource) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set('tab', SOURCE_TO_TAB[source]);
      return params;
    }, { replace: true });
  }, [setSearchParams]);
}
